import type {
  AppNotification,
  NotificationType,
} from './notification-service';

const POST_COMMENT_TARGET_NOTIFICATION_TYPES = new Set<NotificationType>([
  'comment_mention',
  'comment_reaction',
  'post_comment',
]);

export function getNotificationPostPath(
  notification: Pick<AppNotification, 'commentId' | 'postId' | 'type'>,
) {
  if (!notification.postId) {
    return null;
  }

  const postPath = `/posts/${encodeURIComponent(notification.postId)}`;

  if (
    notification.commentId &&
    POST_COMMENT_TARGET_NOTIFICATION_TYPES.has(notification.type)
  ) {
    return `${postPath}?commentId=${encodeURIComponent(notification.commentId)}`;
  }

  return postPath;
}
